<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-container>
            <v-layout>
                <v-card width="100%">
                    <div>
                        <v-btn :disabled="loading" style="float: right" color="primary" @click="paymentRequest">Request a Payment</v-btn>
                    </div>
                    <v-card-title>
                        Ongoing Payment
                    </v-card-title>
                    <v-card-text>
                        <report ref="report" :id="id" :is_captain="true"></report>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import Report from "@/components/accounting/Report";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "Statistics",
        props: ['id'],
        components: {LoadingComponent, Report},
        data() {
            return {
                loading: false
            }
        },
        methods: {
            paymentRequest() {
                this.loading = true;
                this.axios.post('payment/request', {captain_id: this.$route.params.id})
                    .then(() => {
                        this.$refs.report.reset();
                        this.$refs.report.getData();
                    })
                    .catch(err => {
                        let message = '';
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = 'failed cannot request a payment right now';
                        }
                        window.getApp.$emit('SHOW_TOAST', message, 'red');
                    })
                    .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>

</style>